import React, { Component } from 'react'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
// import ArchiveController from './archiveController/class'
import { ArchiveController } from './revised_components/archiveController'
import { UserControl } from './revised_components/userControl'
import { getLocal, setLocal } from '../services/storage'
import { dataSource } from '../services/dataSource'
import Row from 'react-bootstrap/Row'
import { useNavigate } from 'react-router-dom'

import {MARK} from '../shared/Data/typeDirs'
import { TestPage } from './revised_components/testPage'
import { CopyToOppositeController } from './revised_components/copyToOppositeController'

import Language_v2 from "../shared/Objects/language_v2";
import { genId } from "../shared/utils";
import { LANG_V2 } from "../shared/Data/typeDirs";
import { LANG_CATS } from "../shared/Data/typeDirs";
import { useNotificationContext } from "./revised_components/contextProviders/notificationContext";


function requestFileFromUser(accept = ".json", multiple = false) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input')
    input.type = 'file'
    input.style.display = 'none'
    input.accept = accept
    input.multiple = multiple
    input.addEventListener('change', () => {
      document.body.removeChild(input)
      if (input.files.length > 0) {
        resolve(multiple ? [...input.files] : input.files[0])
      } else {
        reject(new Error('No file selected'))
      }
    })
    document.body.appendChild(input)
    input.click()
  })
}

class AdminComponent extends Component {
  constructor(props) {
    super(props)
    props.setTitle('Admin Area')
    //props.setMenuOptions()
    this.state = {
      inspList: null,
      repList: null,
      langList: null,
      currentLanguage: null,
      importingLanguage: false,
      betaAccess: 'Enable beta access',
      clientRef: React.createRef(),
      onClicked: this.onClicked.bind(this),
      beta: this.beta.bind(this),
      startTimer: this.startTimer.bind(this),
      endTimer: this.endTimer.bind(this),
      timeFunction: this.timeFunction.bind(this),
      clickTest: this.clickTest.bind(this)
    }
    this.importLanguageFile = this.importLanguageFile?.bind(this)
  }

  async componentDidMount() {
    try {
      const langs = await dataSource('remDb')[LANG_V2].toArray()
      this.setState({ langList: langs })
    } catch (e) {
      console.error('Failed to load languages', e)
      this.setState({ langList: [], currentLanguage: null })
    }
  }

  async timeFunction(callback) {
    return new Promise(async resolve => {
      this.state.startTimer(true)
      let res = await callback()
      this.state.endTimer()
      console.log('function executed in', this.time / 1000, 'seconds')
      return resolve(res)
    })
  }

  startTimer(log = false) {
    this.time = 0
    let timeId = setInterval(() => {
      if (log && this.time % 1000 === 0) console.log('timing function...', `${this.time / 1000}s`)
      this.time += 100
    }, 100)

    this.setState({ timeId })
    // return time
  }
  endTimer() {
    let { timeId } = this.state
    clearInterval(timeId)
  }

  onClicked(type, info) {
    this.props.navigate(`/${type}/${info.original._id}`)
  }

  handleChange(evt) {
    this.setState({ [evt.target.id]: evt.target.value })
  }

  async beta() {
    const betaAccessStatus = await getLocal('betaAccess')
    if (betaAccessStatus && betaAccessStatus === 'true') {
      await setLocal('betaAccess', "false")
      // await setLocal('locOpHistId', {})
      await setLocal('photoQueue', {})
      await setLocal('markCountRep', {})
      await setLocal('markCountInsp', {})
      try {
        // await db.delete()
      } catch (e) { }
      this.setState({ betaAccess: 'Enable beta access' })
      window.location.reload()

    } else {
      await setLocal('betaAccess', "true")
      // await setLocal('locOpHistId', {})
      await setLocal('photoQueue', {})
      await setLocal('markCountRep', {})
      await setLocal('markCountInsp', {})
      try {
        // await db.delete()
      } catch (e) { }

      this.setState({ betaAccess: 'Disable beta access' })
      window.location.reload()

    }
  }

  async clickTest() {
    let res = await dataSource('remDb')[MARK].findImagesByInspClient(this.state.clientRef.current.value)
    console.log('got this from querying all images', res)
  }
  
  async importLanguageFile() {
    try {
      this.setState({ importingLanguage: true })
      let file = await requestFileFromUser('.json', false)
      const fileName = (file && file.name) || ''
      const isJsonByExt = fileName.toLowerCase().endsWith('.json')
      const isJsonByType = (file.type || '').toLowerCase() === 'application/json'
      if (!isJsonByExt && !isJsonByType) {
        this.props.displayNotif('warning', 'Please select a JSON file (.json).')
        this.setState({ importingLanguage: false })
        return
      }
      let text = await file.text()
      let {name, schema, source} = JSON.parse(text)
      const newName = ('Full Lanugage').trim()
      // Check duplicate names (case-insensitive)
      const existing = await dataSource('remDb')[LANG_V2].toArray()
      const exists = existing.some(l => (l.name || '').trim().toLowerCase() === newName.toLowerCase())
      if (exists) {
        this.props.displayNotif('warning', `Language with name "${newName}" already exists. Please rename the file before importing.`)
        this.setState({ importingLanguage: false })
        return
      }
      let newLanguage = {name: newName, ...source, _id: genId()}
      newLanguage = new Language_v2(newLanguage)
      for (let type of LANG_CATS) { newLanguage[type] = source[type].map(itm=>({...itm, _changed:true})) }
      await dataSource('remDb')[LANG_V2].put(newLanguage)
      const langs = await dataSource('remDb')[LANG_V2].toArray()
      this.setState({ langList: langs })
      this.props.displayNotif('success', `Imported language "${newName}"`)
    } catch (e) {
      console.error('Failed to import language file', e)
      this.props.displayNotif('danger', 'Failed to import language file')
    } finally {
      this.setState({ importingLanguage: false })
    }
  }

  render() {
    // const {inspList, repList, onClicked} = this.state
    const { user } = this.props
    const { beta, betaAccess, importingLanguage } = this.state
    
    /// FIX PEPPERWOOD


    /// END FIX PEPPERWOOD
    const openDev = () => {
      //ipcRenderer.send('toggle-devtools')
    }
    return (
      <Container fluid className="large-content scrollable">

        <Tabs defaultActiveKey="arch" id="inspection-tabs">
        
          <Tab eventKey="arch" title="Archive">
            <ArchiveController

            />
          </Tab>

          <Tab eventKey="users" title="Users">
            <UserControl/>
          </Tab>
          <Tab eventKey="another" title="Tools">
            <Row>
              <Button onClick={openDev} key="save" variant="info">
                Open dev tools
              </Button>
              <Button onClick={beta} key="beta" variant="info">
                {betaAccess}
              </Button>


            </Row>
            <Row>
              <CopyToOppositeController />
            </Row>
            {/* <Button onClick={resetLocalDb} key="resetdb" variant="danger">
              Reset Local DB
            </Button> */}

          </Tab>

          <Tab eventKey='test_new_notif' title='TEST NEW NOTIFICATIONS'>
            <TestPage />
          </Tab>

          <Tab eventKey='language' title='Classification Language setting'>  
            
            {(!this.state.langList || this.state.langList.length === 0) && (
              <div style={{margin: '10px 0'}}>
                <Button onClick={this.importLanguageFile} disabled={importingLanguage}>
                  {importingLanguage && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: 8 }}
                    />
                  )}
                  {importingLanguage ? 'Importing...' : 'Import Language file (.json)'}
                </Button>
              </div>
            )}
           
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th style={{width:'50%'}}>Name</th>
                  <th style={{width:'50%'}}>ID</th>
                </tr>
              </thead>
              <tbody>
                {(this.state.langList && this.state.langList.length > 0) ? this.state.langList.map(lang => (
                  <tr key={lang._id}>
                    <td>{lang.name || '(unnamed)'}</td>
                    <td>{lang._id}</td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={2}>No language files found. Please add it using button above.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </Tab>
        </Tabs>
      </Container>
    )
  }
}

// Wrapper component to provide navigation
export function Admin(props) {
  const navigate = useNavigate()
  const displayNotif = useNotificationContext()
  return <AdminComponent {...props} navigate={navigate} displayNotif={displayNotif} />
}
